var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuobi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F2F8F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4248 8.44995C12.0992 12.1282 8.42528 15.4562 7.18332 17.5581C5.99238 19.5736 5.57753 21.4786 6.4487 25.158C6.49495 25.3533 6.29944 25.524 6.11704 25.4403C4.56064 24.7259 0.599611 22.583 0.599609 17.4743C0.599607 10.2682 8.57076 10.0108 8.19615 0.25777C8.18862 0.0617187 8.40309 -0.0715263 8.56352 0.0414217C11.1713 1.87748 12.7352 4.94398 12.4248 8.44995Z",
    fill: "#0CA28B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22542 25.7316C7.13191 25.703 7.0667 25.6178 7.063 25.5201C6.97228 23.1296 8.25847 21.5674 9.70065 20.4084C12.9018 17.8358 14.8756 14.3616 14.0944 10.3418C14.0478 10.102 14.3288 9.94373 14.4858 10.1309C15.2388 11.0286 16.0059 12.2452 16.4304 13.1321C18.4779 17.5306 17.3852 22.5713 12.4857 25.1149C10.9518 25.8765 9.13035 26.3136 7.22542 25.7316Z",
    fill: "#3BBEAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/huobi.2f66de8f4ce97162eaeaefafda75ff0e.svg";
export { ForwardRef as ReactComponent };